/* eslint-disable no-console */
import ServiceBase from './serviceBase';
import {
  FlowContainer,
  FlowCreate,
  FlowFeedbackProvided,
  FlowNextReview,
  OperFlowService,
  FlowFeedbackForSave,
  InviteReviewers,
  FlowRestart,
  FlowRelate,
  FlowReviewerDelete,
  FlowEsapInfo,
  FlowSprMission,
  FlowSprDoc,
} from './types/Flow';

const NOT_IMPLEMENTED_ERROR_MESSAGE = 'Not Implemented';

class OperEsrsService extends ServiceBase implements OperFlowService {
  create = async (data: FlowCreate): Promise<number> =>
    this.post<number>('operationesrs/create', data);

  getFlow = async (operationId: number): Promise<FlowContainer> =>
    this.get<FlowContainer>(`operationesrs/${operationId}`);

  sendForNextReview = async (data: FlowNextReview): Promise<void> =>
    this.post<void>('operationesrs/next', data);

  provideFeedback = async (data: FlowFeedbackProvided): Promise<void> =>
    this.post<void>('operationesrs/feedback', data);

  saveFeedback = async (data: FlowFeedbackForSave): Promise<void> =>
    this.post<void>('operationesrs/savefeedback', data);

  applyComplianceChanges = async (flowId: number): Promise<void> =>
    this.post<void>(`operationesrs/${flowId}/applycompliance`);

  discardComplianceChanges = async (flowId: number): Promise<void> =>
    this.post<void>(`operationesrs/${flowId}/discardcompliance`);

  openWord = async (flowId: number): Promise<string> =>
    this.post<string>(`operationesrs/${flowId}/wordlink`);

  downloadDocVersion = async (id: number): Promise<boolean> => {
    await this.download(`operationesrs/version/${id}`);
    return true;
  };

  upload = async (formData: FormData): Promise<boolean> => {
    const result = await this.post<boolean>('operationesrs/upload', formData);
    return result;
  };

  restart = async (data: FlowRestart): Promise<void> =>
    this.post<void>('operationesrs/restart', data);

  relate = async (data: FlowRelate): Promise<void> => this.post<void>('operationesrs/relate', data);

  inviteReviewers = async (data: InviteReviewers): Promise<void> =>
    this.post<void>('operationesrs/invite-reviewers', data);

  applyActionPlanChanges = async (flowId: number): Promise<void> => {
    console.log(flowId);
    throw new Error(NOT_IMPLEMENTED_ERROR_MESSAGE);
  };

  discardActionPlanChanges = async (flowId: number): Promise<void> => {
    console.log(flowId);
    throw new Error(NOT_IMPLEMENTED_ERROR_MESSAGE);
  };

  applyIndicatorsChanges = async (flowId: number): Promise<void> =>
    this.post<void>(`operationesrs/${flowId}/applyindicators`);

  discardIndicatorsChanges = async (flowId: number): Promise<void> =>
    this.post<void>(`operationesrs/${flowId}/discardindicators`);

  getSPRRationale = async (flowId: number): Promise<FlowSprDoc> => {
    console.log(flowId);
    throw new Error(NOT_IMPLEMENTED_ERROR_MESSAGE);
  };

  getSPRMissions = async (operationId: number): Promise<FlowSprMission[]> => {
    console.log(operationId);
    throw new Error(NOT_IMPLEMENTED_ERROR_MESSAGE);
  };

  removeReviewers = async (data: FlowReviewerDelete): Promise<void> =>
    this.post<void>('operationesrs/remove-reviewers', data);

  checkEsap = async (flowId: number): Promise<FlowEsapInfo> =>
    this.get<FlowEsapInfo>(`operationesrs/check-esap/${flowId}`);

  deleteFlow = async (flowId: number, lap?: number | undefined) => {
    let uri = `operationEsrs/${flowId}`;
    if (lap) {
      uri = `${uri}/${lap}`;
    }
    return this.delete<void>(uri);
  };
}

const operEsrsService = new OperEsrsService();

export default operEsrsService;
